import { useState } from "react";
import { ValidatePhoneNumberView } from "./ValidatePhoneNumberView";
import { UseFormMethods } from "react-hook-form";
import { INetwork, IPortinForm } from "@features/PortIn/interface/IPortinForm";
import { EPortInStep } from "@features/PortIn/components/ValidatePhoneNumber/enum/EPortInStep";

interface IParams {
    formMethods: UseFormMethods<IPortinForm>;
    phoneNumberSelected: string;
    previousPhoneNumber?: string;
    variantStyleButton: "outlined" | "contained";
    setIsFinished(): void;
    setCurrentProvider(currentProvider: INetwork): void;
    setPhoneNumberSelected(phoneNumber: string): void;
}

export const ValidatePhoneNumber = (props: IParams) => {
    const {
        phoneNumberSelected,
        setPhoneNumberSelected,
        variantStyleButton,
        previousPhoneNumber,
        setIsFinished,
        setCurrentProvider,
        formMethods,
    } = props;

    const [otpId, setOtpId] = useState("");
    const [portInStep, setPortInStep] = useState(EPortInStep.getCode);
    const [hasTooManyAttempt, setHasTooManyAttempt] = useState(false);

    const updatePortInStep = (step: EPortInStep) => {
        setPortInStep(step);
    };

    return (
        <ValidatePhoneNumberView
            formMethods={formMethods}
            hasTooManyAttempt={hasTooManyAttempt}
            otpId={otpId}
            phoneNumberSelected={phoneNumberSelected}
            portInStep={portInStep}
            previousPhoneNumber={previousPhoneNumber}
            setCurrentProvider={setCurrentProvider}
            setHasTooManyAttempt={setHasTooManyAttempt}
            setIsFinished={setIsFinished}
            setOtpId={setOtpId}
            setPhoneNumberSelected={setPhoneNumberSelected}
            updatePortInStep={updatePortInStep}
            variantStyleButton={variantStyleButton}
        />
    );
};
